<script>
    import { user } from './stores/login_store.js'

</script>

<style>
    .customnav {
        padding: 0.5em 2em;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }

    .nav-left > a {
        color: white;
    }
</style>

<nav class="customnav">
    <div class="nav-left">
        <a href="/">
            <strong>ksuite pb</strong>
        </a>
    </div>
    <div class="nav-right">
        {#if $user }
            <span>{$user.username} &bull; <a href="/auth/logout">log out</a></span>
        {:else}
            <span><a href="/auth/oauth2">log in</a></span>
        {/if}
    </div>

</nav>
